import * as d3 from 'd3'
import * as topojson from 'topojson-client'
import * as flubber from 'flubber'
import Chart from '../chart'
//import { regressionQuad } from 'd3-regression'

import './BeforeAfterBelgianMap.css'

import beTopo from './be.json';
import provinces from './provinces.json'
import unemploymentRatio from './unemploymentRatio.json'

export default class BeforeAfterBelgianMap extends Chart {
  create() {
    this.svg = super.createRoot();
    this.belgiumTopojson = beTopo;

    this.numberOfColors = 9; 
    this.main = this.svg.append('g')
      .attr('class', 'main')
      .attr('transform', `translate(${this.props.margin.left},${this.props.margin.top})`);
    
    this.map = this.main.append('g')
      .attr('class', 'map');

    this.beforeClip = this.main.append("clipPath")
      .attr("id", "before-clip")
      .append("rect")
      .attr("x", 0)
      .attr("y", 0)
      .attr("width", this.props.width)         
      .attr("height", this.props.height); 
    
    this.afterClip = this.main.append("clipPath")
      .attr("id", "after-clip")
      .append("rect")
      .attr("x", this.props.width)
      .attr("y", 0)
      .attr("width", 0)         
      .attr("height", this.props.height); 

    this.beforeMap = this.main.append('g')
      .attr('class', 'beforeMap')
      .attr("clip-path", "url(#before-clip)")

    this.afterMap = this.main.append('g')
      .attr('class', 'afterMap')
      .attr("clip-path", "url(#after-clip)")

    this.backgroundProvinces = this.afterMap.append('g')
      .attr('class', 'backgroundProvinces')
      .style("pointer-events", "none")

    this.beforeMunicipalities = this.beforeMap.append('g')
      .attr('class', 'beforeMunicipalities')

    this.afterMunicipalities = this.afterMap.append('g')
      .attr('class', 'afterMunicipalities')
    
    this.municipalityCircles = this.afterMap.append('g')
      .attr('class', 'municipalityCircles')
      .style('visibility', 'hidden')

    this.regionSeparator = this.afterMap.append('g')
      .attr('class', 'regionSeparator')
      .style('opacity', 0)
    
    this.provinces = this.main.append('g')
      .attr('class', 'provinces')
      .append("path")
      .attr("fill", "none")
      .attr("stroke", "white")
      .attr("stroke-width", 2)
      .style("pointer-events", "none")

    this.provinceLabels = this.main.append('g')
      .attr('class', 'provinceLabels')
      .style("pointer-events", "none")
    
    this.regions = this.main.append('g')
      .attr('class', 'regions')
      .append("path")
      .attr("fill", "none")
      .attr("stroke", "white")
      .attr("stroke-width", 3)
      .style("pointer-events", "none")
    
    this.highlightedZone = this.main.append('g')
      .attr('class', 'highlightedZone')
      .append('path');
    
    const legend = this.svg.append('g')
      .attr('transform', `translate(${this.props.width * 0.1}, ${this.props.height * 0.9})`)
    
    this.legend = legend.append('g')
      .attr('class', 'legend')
    
    this.pointer = legend.append('circle')
      .attr('class', 'pointer')
      .attr('cy', 4)
      .attr('r', 6)
      .attr('fill', 'black')
      .attr('stroke', 'white')
      .attr('stroke-width', 2)
      .attr('opacity', 0)

    this.slider =  this.main.append("g")
      .attr("class", "slider")
      .style('cursor', 'ew-resize')
      .attr("transform", `translate(${this.props.width}, 0)`)
    
    this.slider   
      .append("rect")
        .attr('fill', 'black')
        .attr("x", -1.5)
        .attr("y", 0)
        .attr("width", 3)         
        .attr("height", this.props.height)
    this.slider
      .append("rect")
        .attr('fill', 'white')
        .attr('stroke', 'black')
        .attr('stroke-width', 3)
        .attr("x", -5)
        .attr("y", this.props.height * 0.45)
        .attr("width", 10)         
        .attr("height", this.props.height * 0.1)
        .style("rx", 3)
        .style("ry", 3); 
    this.slider
      .append('text')
      .attr('x', -10)
      .attr('y', 20)
      .attr('font-size', 18)
      .attr('dominant-baseline', 'middle')
      .attr('text-anchor', 'end')
      .attr('textShadow', 'none')
      .attr('font-weight', 'bold')
      .attr('fill', 'black')
      .text('2010')
    this.slider
      .append('text')
      .attr('x', 10)
      .attr('y', 20)
      .attr('font-size', 18)
      .attr('dominant-baseline', 'middle')
      .attr('text-anchor', 'start')
      .attr('textShadow', 'none')
      .attr('font-weight', 'bold')
      .attr('fill', 'black')
      .text('2018')

    this.tooltip = d3.select('body')
      .append('div')
      .attr('class', 'belgium-map-tooltip')

    this.tooltipHtml = this.tooltip.append('div')
    this.tooltipSvg = this.tooltip.append('svg')
      .attr("width", this.props.width * 0.20)
      .attr("height", 70)

    this.axis = this.svg.append('g')
      .attr('class', 'axis');

    this.xAxis = this.axis.append("g")
      .attr("transform", `translate(0,${this.props.height})`)
      .attr("class", "axis xAxis")

    this.yAxis = this.axis.append("g")
      .attr("class", "axis yAxis")

    this.yAxisLabel = this.axis
      .append('text')
      .attr("class", "yAxisLabel")
      .attr("text-anchor", "start")
      .attr("x", 6)
      .attr("y", 6)
      .text("Unemployment rate");

    this.xAxisLabel = this.axis
      .append('text')
      .attr("class", "xAxisLabel")
      .attr("text-anchor", "end")
      .attr("x", this.props.width - 6)
      .attr("y", this.props.height - 10)
      .text("Proportion of non cancerous population consuming opioids");

    this.trend = this.main
      .append("path")
      .attr("class", "trend")
      .style("fill", "none")
      .style("stroke", "grey")

    let self = this;
    this.slider.call(
      d3.drag()
        .on("start", function(d) { self.dragstarted(this, self) })
        .on("drag", function(d) { self.dragged(this, self) })
        .on("end", function(d) { self.dragended(this, self) })
    )
  }

  dragstarted(d, self) {
    self.dragging = true;
    //d3.select(this).raise().attr("stroke", "black");
  }

  dragged(elem, self) {
    d3.select(elem)
      .attr("transform", `translate(${Math.max(6, Math.min(d3.event.x, self.props.width-6))}, 0)`);
    self.beforeClip
      .attr("width", Math.max(0, d3.event.x))
    self.afterClip
      .attr("x", d3.event.x)
      .attr("width", Math.max(0,self.props.width - d3.event.x))
  }

  dragended(d, self) {
    self.dragging = false;
    //d3.select(this).attr("stroke", null);
  }
  
  update(state) {
    this.insAccessor = state.insAccessor;
    this.valueAccessor = state.valueAccessor;
    this.valueName = state.valueName;
    this.thresholds = state.thresholds;
    this.colorScale = this.getColorScale(state);
    this.radiusScale = this.getRadiusScale();
    this.correlationScale = this.getCorrelationScale();
    this.quotation = state.quotation;

    this.data = state.data;
    this.drawMap(state);
    this.drawLegdend();

    return this.svg.node();
  }
  
  getColorScale(state) {
    if (state.thresholds) {
      if(!Array.isArray(state.thresholds)) console.error("Thresholds has to be an array of numbers")
      const scheme = d3[`scheme${state.colorScheme || 'RdPu'}`][state.thresholds.length]
      return d3.scaleThreshold()
        .domain(state.thresholds)
        .range(scheme)
    } else {
      const scheme = d3[`scheme${state.colorScheme || 'RdPu'}`][this.numberOfColors]
      return d3.scaleQuantize()
        .domain(d3.extent(state.data, d => d[state.valueAccessor]))
        .range(scheme)
     }
  }

  getRadiusScale() {
    const populationMax = d3.max(beTopo.objects.communes.geometries,
      c => c.properties.population)
    return d3.scaleSqrt()
        .domain([0, populationMax])
        .range([1, this.props.width * 0.02]) 
  }
  
  getCorrelationScale() {
    const maxUnemploymentRatio = Math.max(...Object.values(unemploymentRatio))
    return d3.scaleLinear()
      .domain([0, maxUnemploymentRatio])
      .range([this.props.height, 0])
      .nice() 
  }

  getValueScale(data) {
    const maxValue = d3.max(data, d => d.properties.valueAfter)
    return d3.scaleLinear()
      .domain([0.05, maxValue])
      .range([0, this.props.width]) 
      .nice()
  }

  drawMap(state) { 
    const self = this
    /*const insDataMapping = this.data.reduce( (mapping, d) => {
      mapping[d[this.insAccessor || 'ins']] = d[this.valueAccessor];
      return mapping;
    }, {});*/
    const insDataMapping = this.data
    
    this.projection = d3.geoMercator()
      .fitExtent(
        [[0,0],[this.props.width * 0.95, this.props.height]], 
        topojson.feature(this.belgiumTopojson, this.belgiumTopojson.objects.regions))
  
    this.path = d3.geoPath()
      .projection(this.projection)
    
    const data = topojson.feature(this.belgiumTopojson, this.belgiumTopojson.objects.communes).features
      .map((g, i) => {
        const evolution = insDataMapping[g.properties.ins] ? insDataMapping[g.properties.ins][this.valueAccessor] : null;
        const evolutionFullYear = insDataMapping[g.properties.ins] ? insDataMapping[g.properties.ins].opioidFullYearRatio : null;
        const valueBefore = insDataMapping[g.properties.ins] ? insDataMapping[g.properties.ins][this.valueAccessor][0].value : null;
        const colorBefore = valueBefore != null && !isNaN(valueBefore) ? this.colorScale(valueBefore) : "#efefef";
        const valueAfter = insDataMapping[g.properties.ins] ? insDataMapping[g.properties.ins][this.valueAccessor][insDataMapping[g.properties.ins][this.valueAccessor].length-1].value : null;
        const colorAfter = valueAfter != null && !isNaN(valueAfter) ? this.colorScale(valueAfter) : "#efefef";
        const correlationValue = unemploymentRatio[g.properties.ins] 
        return {
          ...g,
          properties: {
            ...g.properties, 
            colorBefore,
            colorAfter,
            valueBefore,
            valueAfter,
            correlationValue,
            evolution,
            evolutionFullYear,
          }
        }
      })

    this.valueScale = this.getValueScale(data);

    this.provinces
      .attr("d", this.path(topojson.feature(this.belgiumTopojson, this.belgiumTopojson.objects.provinces)));

    this.regions
      .attr("d", this.path(topojson.feature(this.belgiumTopojson, this.belgiumTopojson.objects.regions)));

    this.municipalities = this.beforeMunicipalities.selectAll("path")
        .data(data)
    
    this.municipalitiesEnter = this.municipalities.enter().append("path")
      .attr("fill", d => d.properties.colorBefore)
      .attr("stroke", "white")
      .attr("stroke-linejoin", "round")
      .attr("stroke-width", 0.5)
      .attr("d", d => this.path(d))
      .style("cursor", "pointer")
      .on('mouseenter', function(d) { self.updateSelection(d) })
      .on("mousemove", function(d) { self.moveTooltip(d) })
      .on('mouseleave', function() { self.updateSelection(null) })

    this.municipalitiesMerge = this.municipalities
      .merge(this.municipalitiesEnter)
      .attr("fill", d => d.properties.colorBefore)

    this.municipalitiesAfter = this.afterMunicipalities.selectAll("path")
      .data(data)
      
    this.municipalitiesAfterEnter = this.municipalitiesAfter
      .enter().append("path")
      .attr("stroke", "white")
      .attr("stroke-linejoin", "round")
      .attr("stroke-width", 0.5)
      .attr("d", d => this.path(d))
      .style("cursor", "pointer")
      .on('mouseenter', function(d) { self.updateSelection(d) })
      .on("mousemove", function(d) { self.moveTooltip(d) })
      .on('mouseleave', function() { self.updateSelection(null) })

    this.municipalitiesAfterMerge = this.municipalitiesAfter
      .merge(this.municipalitiesAfterEnter)
      .attr("fill", d => d.properties.colorAfter)

    this.municipalityCirclesData = this.municipalityCircles.selectAll("circle")
      .data(data)
      
    this.municipalityCirclesEnter = this.municipalityCirclesData
      .enter().append("circle")
      .attr("stroke", "white")
      .attr("stroke-width", 0.5)
      .style("cursor", "pointer")
      .on('mouseenter', function(d) { self.updateSelection(d, true) })
      .on("mousemove", function(d) { self.moveTooltip(d) })
      .on('mouseleave', function() { self.updateSelection(null) })

    this.municipalityCirclesMerge = this.municipalityCirclesData
      .merge(this.municipalityCirclesEnter)
      .attr("fill", d => d.properties.colorAfter)
      //.attr("cx", d => this.projection(d.properties.centroid)[0])
      //.attr("cy", d => this.projection(d.properties.centroid)[1])
      .attr("r", d => this.radiusScale(d.properties.population))

    this.backProvinceShapes = this.backgroundProvinces.selectAll("path")
      .data(topojson.feature(this.belgiumTopojson, this.belgiumTopojson.objects.provinces).features)
    
    this.backProvinceShapesEnter = this.backProvinceShapes
      .enter()
        .append("path")
      .attr("fill", "#f5f5f5")
      .attr("stroke", "white")
      .attr("stroke-width", 2)
    
    this.backProvinceShapesMerge = this.backProvinceShapes
      .merge(this.backProvinceShapesEnter)
      //.attr("d", d => this.path(d))

    this.provinceLabelsData = this.provinceLabels.selectAll("text")
      .data(topojson.feature(this.belgiumTopojson, this.belgiumTopojson.objects.provinces).features)
    
    this.provinceLabelsEnter = this.provinceLabelsData
      .enter()
        .append("g")
        .attr('class', 'provinceLabel')

    this.provinceLabelsEnter
      .append("text")
      .attr("x", d => this.projection(d.properties.centroid)[0])
      .attr("y", d => (this.projection(d.properties.centroid)[1] - (this.radiusScale(d.properties.population) * 2)) - 10 )
      .attr('font-size', 12)
      .attr('dominant-baseline', 'middle')
      .attr('text-anchor', 'middle')
      .style('font-weight', 'bold')
      .attr('fill', 'black')
      .text(d => provinces[d.properties.name].fullName)
    this.provinceLabelsEnter
      .append("text")
      .attr("x", d => this.projection(d.properties.centroid)[0])
      .attr("y", d => (this.projection(d.properties.centroid)[1] + (this.radiusScale(d.properties.population) * 2)) + 10 )
      .attr('font-size', 12)
      .attr('dominant-baseline', 'middle')
      .attr('text-anchor', 'middle')
      .attr('fill', 'black')
      .text(d => `${Math.round(provinces[d.properties.name][this.valueAccessor]*1000)/10} %` )

    this.provinceLabelsMerge = this.provinceLabelsData
      .merge(this.provinceLabelsEnter)

    const bruxelles = this.belgiumTopojson.objects.provinces.geometries.find(p => p.properties.name === null)
    const brusselsPosition = this.projection(bruxelles.properties.centroid);
    const brusselsRadius = this.radiusScale(bruxelles.properties.population) * 2;
    this.drawRegionSeparator(brusselsPosition, brusselsRadius);

    if (state.communeShape === 'circle') {
      if (this.communeShape !== 'circle') {
        this.municipalitiesAfterMerge
          .transition()
          .delay(2000)
          .duration(3000)
          .attrTween('d', d => {
            const center = this.projection(d.properties.centroid)
            return flubber.toCircle(this.path(d), center[0], center[1], this.radiusScale(d.properties.population));
          })
        this.provinces
          .transition()
          .delay(2000)
          .duration(2000)
          .attr('opacity', 0)
        this.regions
          .transition()
          .delay(2000)
          .duration(3000)
          .attr('opacity', 0)
        this.communeShape = 'circle';
      }
    } else {
      this.municipalitiesAfterMerge
        .attr('d', d => this.path(d))
      this.afterMunicipalities
        .style('opacity', 1)
      this.municipalityCircles
        .style('visibility', 'hidden')
      this.provinces.attr('opacity', 1)
      this.regions.attr('opacity', 1)
      this.communeShape = 'geoShape';
    }

    if (state.provinceShape === 'circle') {
      if (this.provinceShape !== 'circle') {
        this.backProvinceShapesMerge
          .transition()
          .delay(d => d.properties.provinceOrder * 500)
          .duration(3000)
          .attrTween('d', d => {
            const center = this.projection(d.properties.centroid)
            const radius = this.radiusScale(d.properties.population) * 2
            return flubber.toCircle(this.path(d), center[0], center[1], radius);
          });
        this.provinceLabels
          .selectAll('.provinceLabel')
          .transition()
          .delay(d => state.regionalView ? 0 : (d.properties.provinceOrder * 500) + 3000)
          .duration(state.regionalView ? 0 : 1000)
          .style("opacity", state.regionalView ? 0 : 1)

        this.afterMunicipalities
          .style('opacity', 0)
        this.municipalitiesAfterMerge
          .style('visibility', 'hidden') 
        this.municipalityCirclesMerge
          .style('visibility', 'visible')
          .transition()
          .delay(d => d.properties.provinceOrder * 500)
          .duration(3000)
          .attr("cx", d => this.projection(d.properties.communeRegroupPosition)[0])
          .attr("cy", d => this.projection(d.properties.communeRegroupPosition)[1] - (d.properties.province === "BE-VWV" ? this.props.height * 0.03 : 0))
        this.provinceShape = 'circle';
      }
    } else {
      this.backProvinceShapesMerge
        .attr('d', d => this.path(d))
      this.afterMunicipalities
        .style('opacity', 1)
      this.municipalityCirclesMerge
        .style('visibility', 'hidden')
        .attr("cx", d => this.projection(d.properties.centroid)[0])
        .attr("cy", d => this.projection(d.properties.centroid)[1])
      this.municipalitiesAfterMerge
        .style('visibility', 'visible') 
      this.provinceShape = 'geoShape';
      this.provinceLabels
        .selectAll('.provinceLabel')
        .style("opacity", 0)
    }

    if (state.regionalView) {
      //if (!this.regionalView) {
        this.regionSeparator
          .transition()
          .duration(500)
          .style('opacity', 1);
        this.municipalityCirclesMerge
          .transition()
          .duration(500)
          .style("fill", d => d.properties.region === 'BE-VLG' ? '#E91E63' : (d.properties.region === 'BE-BRU' ? '#FFB300' : 'dodgerblue'))
          .attr("cx", d => this.projection(d.properties.communeRegroupPosition)[0])
          .attr("cy", d => this.projection(d.properties.communeRegroupPosition)[1] - (d.properties.province === "BE-VWV" ? this.props.height * 0.03 : 0))
        this.legend
          .attr("opacity", 0)
        this.provinceLabels
          .selectAll('.provinceLabel')
          .style("opacity", 1)
        this.backProvinceShapesMerge
          .style('opacity', 1)
        this.regionalView = true;
      //}
    } else {
      this.regionSeparator
        .style('opacity', 0);
      this.municipalityCirclesMerge
        .style("fill", d => d.properties.colorAfter)
      this.legend
        .attr("opacity", 1)
      this.backProvinceShapesMerge
        .style('opacity', 1)
      this.provinceLabels
        .selectAll('.provinceLabel')
        .style("opacity", 0)
      this.regionalView = false;
    }

    if (state.scatterplotView) {
      if (!this.scatterplotView) {
        this.regionSeparator
          .transition()
          .duration(500)
          .style('opacity', 0);
        this.municipalityCirclesMerge
          .transition()
          .delay(d => ((11 - d.properties.provinceOrder)**0.7) * 500)
          .duration(3000)
          .attr('cx', d => this.valueScale(d.properties.valueAfter))
          .attr('cy', d => this.correlationScale(d.properties.correlationValue))
        this.provinceLabels
          .selectAll('.provinceLabel')
          .style("opacity", 0)
        this.backProvinceShapesMerge
          .style('opacity', 0)
        this.regionSeparator
          .style('opacity', 0);
        
        this.xAxis.call(d3.axisBottom(this.valueScale)
          .tickFormat(d => `${Math.round(d*100)}%`)
        );
        
        this.yAxis.call(d3.axisLeft(this.correlationScale)
          .tickFormat(d => `${d}%`)
        )

        this.axis
          .transition()
          .style('visibility', 'visible')

        /*const quadraticRegression = regressionQuad()
          .x(d => d.properties.valueAfter)
          .y(d => d.properties.correlationValue)
          .domain([0.05,  0.17]);
        console.log(JSON.stringify(quadraticRegression(data)))*/
        const trendDataPoints = [[0.05,4.545989966997562],[0.050234375000000005,4.552093757985482],[0.05046875000000001,4.558306358543483],[0.050703125,4.564627768671563],[0.050937500000000004,4.5710579883697235],[0.051171875000000006,4.577597017637965],[0.05140625,4.584244856476285],[0.051640625,4.591001504884687],[0.051875000000000004,4.5978669628631685],[0.052109375000000006,4.604841230411731],[0.05234375000000001,4.611924307530373],[0.052578125,4.619116194219096],[0.052812500000000005,4.626416890477898],[0.05304687500000001,4.633826396306781],[0.05328125,4.641344711705744],[0.053515625000000004,4.648971836674788],[0.053750000000000006,4.656707771213911],[0.05398437500000001,4.664552515323114],[0.05421875000000001,4.672506069002399],[0.054453125000000005,4.6805684322517624],[0.05468750000000001,4.688739605071207],[0.05492187500000001,4.697019587460732],[0.055156250000000004,4.705408379420337],[0.055390625000000006,4.713905980950022],[0.05562500000000001,4.722512392049788],[0.056093750000000005,4.740051642959559],[0.0565625,4.75802613214965],[0.057031250000000006,4.776435859620064],[0.0575,4.7952808253707975],[0.05796875,4.814561029401853],[0.0584375,4.834276471713229],[0.05890625,4.854427152304925],[0.059375,4.875013071176943],[0.05984375,4.896034228329281],[0.0603125,4.917490623761941],[0.060781249999999995,4.93938225747492],[0.06125,4.961709129468222],[0.06171875,4.984471239741843],[0.0621875,5.007668588295786],[0.06265625,5.03130117513005],[0.063125,5.055369000244635],[0.0640625,5.104810365314767],[0.065,5.155992683506184],[0.06593750000000001,5.208915954818883],[0.066875,5.263580179252864],[0.0678125,5.319985356808132],[0.06875,5.378131487484682],[0.06968750000000001,5.438018571282516],[0.07062500000000001,5.499646608201634],[0.0715625,5.563015598242034],[0.07250000000000001,5.628125541403718],[0.07343750000000002,5.694976437686688],[0.07437500000000001,5.763568287090939],[0.07625000000000001,5.905974845263292],[0.07812500000000001,6.055345215920782],[0.08000000000000002,6.211679399063405],[0.08187500000000002,6.374977394691161],[0.08375000000000002,6.545239202804053],[0.08562500000000002,6.722464823402079],[0.08750000000000002,6.90665425648524],[0.08937500000000002,7.097807502053534],[0.09125000000000003,7.295924560106963],[0.09500000000000001,7.713050113669223],[0.09875,8.15803091717202],[0.10250000000000001,8.630866970615354],[0.10625000000000001,9.131558273999229],[0.11000000000000001,9.66010482732364],[0.11750000000000001,10.800763683794072],[0.125,12.052843540026652],[0.1325,13.416344396021387],[0.14,14.891266251778267],[0.15500000000000003,18.175372962578482],[0.17,21.90516367242729]];
        this.trend
          .datum(trendDataPoints)
          .transition()
          .duration(2000)
          .delay(2500)
          .attr("d", d3.line()
            .x(d => this.valueScale(d[0]))
            .y(d => this.correlationScale(d[1]))
          )
          .style("opacity", 1);

        this.scatterplotView = true;
      }
    } else {
      /*this.municipalityCirclesMerge
        .transition()
        .delay(d => d.properties.provinceOrder * 500)
        .duration(3000)
        .attr('cx', d => this.valueScale(d.properties.valueAfter))
        .attr('cy', d => this.correlationScale(d.properties.correlationValue))
      this.provinceLabels
        .selectAll('.provinceLabel')
        .style("opacity", 1)
      this.backProvinceShapesMerge
        .style('opacity', 1)
      this.regionSeparator
        .style('opacity', 1);*/
      this.backProvinceShapesMerge
        .style('opacity', 1)
      this.scatterplotView = false;
      this.axis.style('visibility', 'hidden')
      this.trend
        .style("opacity", 0);
    }
    
    const duration = 2000
    if (state.starting || state.afterOnly) {
      this.slider 
        .transition()
        .duration(duration)
        .attr("transform", `translate(${state.afterOnly ? -150 : this.props.width * 0.2}, 0)`)
      this.beforeClip
        .transition()
        .duration(duration)
        .attr("width", state.afterOnly ? -150 : this.props.width * 0.2);
      this.afterClip
        .transition()
        .duration(duration)
        .attr("x", state.afterOnly ? -150 : this.props.width * 0.2)
        .attr("width", this.props.width + 150);
    }
  }
  
  drawLegdend() {
    this.legend.selectAll('*').remove()
    //const formatNumber = d3.format(".0f")
    this.xScale = d3.scaleLinear()
      .domain(d3.extent(this.colorScale.domain()))
      .range([0, this.props.width * 0.4])

    const xAxis = d3.axisBottom(this.xScale)
      .tickSize(13)
      .tickValues(this.colorScale.range().map(d => this.colorScale.invertExtent(d)[0]).filter(d => d))
      .tickFormat(d => `${Math.round(d*100)}%`)

    this.legend.call(xAxis);

    this.legend.select(".domain").remove();

    this.legend.selectAll("rect")
      .data(this.colorScale.range().map(color => {
        var d = this.colorScale.invertExtent(color);
        if (d[0] == null) d[0] = this.colorScale.domain()[0];
        if (d[1] == null) d[1] = this.colorScale.domain()[1];
        return d;
      }))
      .enter().insert("rect", ".tick")
        .attr("height", 8)
        .attr("x", d => this.xScale(d[0]) )
        .attr("width", d => Math.max(0, this.xScale(d[1]) - this.xScale(d[0])) )
        .attr("fill", d => this.colorScale(d[0]) )

    this.legend.append("text")
      .attr("fill", "#000")
      .attr("font-weight", "bold")
      .attr("text-anchor", "start")
      .attr("y", -6)
      .text(this.valueName)
  }

  drawRegionSeparator(brusselsPosition, brusselsRadius) {
    const points = [
      0, 
      (brusselsPosition[0] - (1.5 * brusselsRadius)) / 2, 
      brusselsPosition[0] - (1.5 * brusselsRadius),
      brusselsPosition[0] - (0.9 * brusselsRadius), 
      brusselsPosition[0] + (0.9 * brusselsRadius),
      brusselsPosition[0] + (1.5 * brusselsRadius),
      brusselsPosition[0] + (1.5 * brusselsRadius) + (this.props.width - (brusselsPosition[0] + (1.5 * brusselsRadius))) / 2, 
      this.props.width
    ]
    const curves = [
      points.map((x, i) => ({ x, y: brusselsPosition[1] + (i === 3 || i === 4 ? 1.5 * brusselsRadius : 0) })),
      points.map((x, i) => ({ x, y: brusselsPosition[1] - (i === 3 || i === 4 ? 1.5 * brusselsRadius : 0) }))
    ]
    const regionSeparation = this.regionSeparator.append("g")
      .attr("class", "region-separation")
      .selectAll("path")
      .data(curves)
      
    regionSeparation.enter()
      .append("path")
      .attr("fill", "none")
      .attr("stroke", "grey")
      .attr("stroke-width", 1.5)
      .style("stroke-dasharray", 4)
      .attr("d", d3.line()
        .curve(d3.curveBasis)
        .x(function(d) { return d.x })
        .y(function(d) { return d.y })
      )
  }
  
  updateSelection(zone, light) {
    if (zone && !this.dragging) {
      if(this.tooltip) {
        this.tooltipHtml
          .html(`
            <h2 style="margin-block-start: 0; margin-block-end: 0.5em;">${zone.properties.name.split('#').reverse()[0]}</h2>
          `);
          /*.html(`
            <h2 style="margin-block-start: 0; margin-block-end: 0.5em;">${zone.properties.name.split('#').reverse()[0]}</h2>
            ${light ? '' : `<div>${zone.properties.value !== null ? Math.round(1000 * zone.properties.valueAfter)/10 : 'Unknown'} % de la population (2018)</div>`}
          `);*/

        if (zone.properties.evolution && !light) {
          const max = d3.max(zone.properties.evolution, e => e.value)
          const scaleHeight = d3
            .scaleLinear()
            .domain([0, max])
            .range([0, this.tooltipSvg.attr('height')-30])
          const scaleYear = d3
            .scaleBand()
            .domain([2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018])
            .range([20, this.tooltipSvg.attr('width')-20])
            .paddingInner(0.2)
  
          const tooltipValueBars = this.tooltipSvg.selectAll('.valueBar')
            .data(zone.properties.evolution)
          
          const tooltipValueBarsEnter = tooltipValueBars
            .enter().append("rect")
            .attr('class', 'valueBar')
            .attr("fill", "#e91e63")
            
          tooltipValueBars.merge(tooltipValueBarsEnter)
            .transition()
            .attr('x', d => scaleYear(d.year))
            .attr('y', d => this.tooltipSvg.attr('height') - scaleHeight(d.value) - 15)
            .attr('width', Math.max(0, scaleYear.bandwidth()))
            .attr('height', d => scaleHeight(d.value));

          this.tooltipSvg.selectAll('.xLabel')
            .data([2010, 2014, 2018])
            .enter().append('text')
            .attr('class', 'xLabel')
            .attr('x', d => scaleYear(d) + (scaleYear.bandwidth() / 2) )
            .attr('y', this.tooltipSvg.attr('height'))
            .attr('font-size', 9)
            .attr('dominant-baseline', 'bottom')
            .attr('text-anchor', 'middle')
            .attr('fill', 'grey')
            .text(d => d)

          const yLabels = this.tooltipSvg.selectAll('.yLabel')
            .data(zone.properties.evolution.filter(d => [2010, 2018].includes(d.year)))
          
          const yLabelsEnter = yLabels
            .enter().append('text')
            .attr('class', 'yLabel')
            .attr('font-size', 10)
            .attr('dominant-baseline', 'bottom')
            .attr('text-anchor', 'start')
            .attr('textShadow', 'none')
            .attr('fill', 'black')

          yLabelsEnter.merge(yLabels)
            .attr('x', d => scaleYear(d.year) + (d.year === 2010 ? - 10 : 5) )
            .attr('y', d => this.tooltipSvg.attr('height') - 20 - scaleHeight(d.value))
            .text(d => `${Math.round(1000 * d.value)/10}%`)

          /*const tooltipFullYearValueBars = this.tooltipSvg.selectAll('.fullYearValueBar')
            .data(zone.properties.evolutionFullYear)
          
          const tooltipFullYearValueBarsEnter = tooltipFullYearValueBars
            .enter().append("rect")
            .attr('class', 'fullYearValueBar')
            .attr("fill", "#b0003a")
            
          tooltipFullYearValueBars.merge(tooltipFullYearValueBarsEnter)
            .attr('x', d => scaleYear(d.year))
            .attr('y', d => this.tooltipSvg.attr('height') - scaleHeight(d.value))
            .attr('width', scaleYear.bandwidth())
            .attr('height', d => scaleHeight(d.value));*/

          this.tooltipSvg.style('visibility', 'visible')
          this.tooltipSvg.attr('height', 70)
        } else {
          this.tooltipSvg.style('visibility', 'hidden')
          this.tooltipSvg.attr('height', 0)
        }
        
        this.tooltip
          .style("visibility", "visible");
      }
      if(!light){
        this.pointer
          .transition()
          .attr('cx', this.xScale(zone.properties.valueAfter))
          .attr('opacity', zone.properties.value !== null ? 1 : 0)
        this.highlightedZone
          .attr("d", this.path(zone))
          .attr("fill", "none")
          .attr("stroke", "black")
          .attr("stroke-width", 3)
          .style('opacity', 1)
      }
    } else {
      if(this.tooltip) {
        this.tooltip.style('visibility', 'hidden')
        this.tooltipSvg.style('visibility', 'hidden')
      }
      this.pointer
        .transition()
        .attr('cx', 0)
        .attr('opacity', 0)
      this.highlightedZone
        .style('opacity', 0)
    }
  }
  
  moveTooltip (zone) {
    if(this.tooltip){
      //const pos = this.projection(zone.properties.centroid)
      this.tooltip
        .style('width', 0.2 * this.props.width)
        .style('right', d3.event.pageX > this.props.width / 2 ? `calc(100vw - ${d3.event.pageX - 10}px)` : 'auto')
        .style('left', d3.event.pageX <= this.props.width / 2 ? `${d3.event.pageX + 10}px` : 'auto')
        .style('bottom', d3.event.pageY > this.props.height / 2 ? `calc(100vh - ${d3.event.pageY - 10}px)` : 'auto')
        .style('top', d3.event.pageY <= this.props.height / 2 ? `calc(${d3.event.pageY + 10}px)` : 'auto');
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/charts/BeforeAfterBelgiumMap/BeforeAfterBelgianMap.js